import type { IPlace } from "@bbj-types/address";
import { type AutocompleteProps, CircularProgress } from "@mui/material";
import type React from "react";
import { useState } from "react";
import { AutocompletePlacesUniqBase } from "./autocomplete";
import { type IPlacesQuery, useAutocompletePlaces } from "./logics";

type TAutocompletePlacesUniqProps<
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  ChipComponent extends React.ElementType = "div",
> = Omit<
  AutocompleteProps<IPlace, Multiple, DisableClearable, false, ChipComponent>,
  "options" | "loading" | "onInputChange" | "getOptionLabel" | "isOptionEqualToValue"
> & {
  permissions?: string | string[];
  query?: IPlacesQuery;
};

export const AutocompletePlaces = <Multiple extends boolean | undefined, DisableClearable extends boolean | undefined>({
  query,
  ...props
}: TAutocompletePlacesUniqProps<Multiple, DisableClearable>) => {
  const [inputValue, setInputValue] = useState("");
  const { loading, getDebouncePlaces, options, loadOnOpen } = useAutocompletePlaces(query);
  return (
    <AutocompletePlacesUniqBase
      {...props}
      loading={loading}
      loadingText={<CircularProgress color="primary" size={15} />}
      options={inputValue.length ? options : []}
      inputValue={inputValue}
      onInputChange={(_, value) => {
        getDebouncePlaces(value);
        setInputValue(value);
      }}
      onOpen={loadOnOpen}
      noOptionsText={
        inputValue.length > 0
          ? "Pas de résultat."
          : "Pas de résultat. Saisissez au moins 1 caractère pour avoir des propositions."
      }
    />
  );
};
